import React, { useEffect, useState, useContext, useRef } from "react";
import {
    get_account,
    configure,
    account_view,
    post_watchlist,
    get_models,
    tickers,
    run_trader,
    get_jobs,
    clear_job,
    get_configure,
    account_delete,
    get_data
} from "../LaytraderLibrary/LaytraderRequest";

import ReactDOM from 'react-dom';

import { AccountContext } from '../Accounts';
import { useHistory, useLocation } from 'react-router-dom';
import {
    AccountContainer,
    FormSelectDropdownContainer,
    FormLabel,
    Form,
    FormInput,
    WatchlistRow,
    FormH1,
    FormButton,
    DropdownContainer,
    FormInputDropdownContainer,
    RemoveWLButton,
    CloseComponentButton,
    ButtonHeader,
    GraphComponentContainer,
    JobsContainer,
    FormSelect,
    AccountRow,
    StyledIconSlashButton,
    StyledIconButton,
    FormH3,
    RowContainer,
    FormH2,
    HeaderContainer,
    SpinningIcon,
    RegularText,
    CheckboxContainer,
    StyledCheckbox,
    InputItemContainer,
    ToolTipPointer,
    ToolTipContainer,
    ToolTipTopLine,
    ToolTipP,
    ToolTipFooter,
    ToolTipControl,
    StyledIconContainer,
    Slider,
    ToggleContainer,
    HiddenCheckbox,
    TipsOn,
    TipsOff,
    ToggleSwitch,
    ToggleWrapper,
    IconWrapper,
    ToggleButtonWrapper,
    TipBox,
    RemoveAccountButton,
    HeaderClose,
    StyledIconLink,
    StyledIconRefresh,
    AccountRow2,
    StyledIconTable,
    StyledIconPie,
    JobsStatusContainer,
    RowInfoStack,
    JSInfoH1,
    JSInfoText
} from './AccountElements';
import PortfolioPieChart from "./portfolioPieChart";
import TradesList from "../TradesForms";
import StockDetails from "../StockDetailsForms";
import RunModal from "../RunModalForms";
import { Height } from "@mui/icons-material";
import ChartStation from "../ChartForms";
import DeleteModal from "../DeleteModalForms";
import WarnModal from "../WarnModalForms";
import LTTable from "./LayTraderTable";
import PortfolioChartStation from "../PortfolioChartForms";

const AccountPage = () => {
    const [status, setStatus] = useState(false);
    const [token, setToken] = useState('');
    const [allStocks, setAllStocks] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [authContext, setAuthContext] = useState(null);
    const [callbackUri, setCallbackUri] = useState('');
    const [jobs, setJobs] = useState([]);
    const [models, setModels] = useState([]);
    const [currentStock, setCurrentStock] = useState('');
    const [currentWatchlistStock, setCurrentWatchlistStock] = useState('');
    const [modalStatus, setModalStatus] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [account, setAccount] = useState({
        "status": false
    });
    const [loading, setLoading] = useState({});
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [awaitingAccountResponse, setAwaitingAccountResponse] = useState(true);
    const [controlsDropdown, setControlsDropdown] = useState(false);
    const [deleteModalStatus, setDeleteModalStatus] = useState(false);
    const [adminUser, setAdminUser] = useState(false);
    const [refreshStatus, setRefreshStatus] = useState(null);
    const [reconFlag, setReconFlag] = useState(true);
    const [warnModalStatus, setWarnModalStatus] = useState(false);
    const [warnExit, setWarnExit] = useState(false);
    const [view, setView] = useState("Table");

    const [demo, setDemo] = useState(false);
    const [demoState, setDemoState] = useState(0);
    const [demoUser, setDemoUser] = useState(false);
    const [last, setLast] = useState(0);
    const [showMods, setShowMods] = useState(false);
    const [checkmarkedAccounts, setCheckmarkedAccounts] = useState([]);
    const { authenticate, getSession, logout } = useContext(AccountContext);
    const history = useHistory();
    const location = useLocation();

    const visibleButton = useRef();
    const dropdownRef = useRef();
    const runTraderRef = useRef();
    const clearJobRef = useRef();
    const reconRef = useRef();
    const connectRef = useRef();
    const adminUsers = process.env.REACT_APP_ADMIN_USERS
    const excludedTickers = process.env.REACT_APP_EXCLUDED_TICKERS ? process.env.REACT_APP_EXCLUDED_TICKERS.split(',') : [];


    useEffect(() => {
        getSession()
            .then(session => {
                setToken(session.accessToken.jwtToken); // Force this to be correct
                // console.log(session.accessToken.jwtToken);
                if (session.accessToken.payload.username === 'demouser') {
                    setDemo(true);
                    setDemoUser(true);
                    setDemoState(2);
                } else if (adminUsers.includes(session.accessToken.payload.username)) {
                    // TODO: Use Cognito RBAC
                    setAdminUser(true);
                }
                setStatus(true);
            })
            .catch(err => {
                console.log(err);
                history.push(`/signin${location.search}`);
            });
    }, []);

    useEffect(() => {
        if (status) {
            const fetchData = async () => {
                const response = await tickers(token);
                const accountResponse = await get_account(token);
                setAllStocks(response ? response.filter(x => !excludedTickers.includes(x.ticker)) : []);
                setAccount(accountResponse);
                if (!accountResponse.accounts) {
                    setDemoState(1);
                }
                if (!accountResponse.status) {
                    if (!accountResponse.accounts) {
                        setAuthContext({ authorization_url: accountResponse.authorization_url, callback_url: accountResponse.callback_url, state: accountResponse.state })
                    }
                    else {
                        const accountResponse = await get_configure(token);
                        setAuthContext({ authorization_url: accountResponse.authorization_url, callback_url: accountResponse.callback_url, state: accountResponse.state })
                    }
                }
                setAwaitingAccountResponse(false);
            };
            fetchData();
        }
    }, [status]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const shouldRefresh = params.get("refresh") === "true";

        if (!shouldRefresh) return;
        if (!token) return;
        if (refreshStatus) return;
        if (demo) return;

        const fetchData = async () => {
            const accountResponse = await get_configure(token);
            setAuthContext({ authorization_url: accountResponse.authorization_url, callback_url: accountResponse.callback_url, state: accountResponse.state });
            setRefreshStatus(true);
        };

        fetchData();
    }, [location.search, token, refreshStatus]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const shouldRefresh = params.get("refresh") === "true";

        if (shouldRefresh && authContext && refreshStatus && reconFlag) {
            openPopup();
        }
    }, [location.search, authContext, refreshStatus]);


    const levenshteinDistance = (a, b) => {
        const dp = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));
        for (let i = 0; i <= a.length; i++) dp[i][0] = i;
        for (let j = 0; j <= b.length; j++) dp[0][j] = j;

        for (let i = 1; i <= a.length; i++) {
            for (let j = 1; j <= b.length; j++) {
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
            }
        }
        return dp[a.length][b.length];
    };

    const sortByRelevancy = (input, all) => {
        const rel = all.sort((a, b) => {
            if (a.ticker.toLowerCase().startsWith(input.toLowerCase()) && !b.ticker.toLowerCase().startsWith(input.toLowerCase())) return -1;
            if (b.ticker.toLowerCase().startsWith(input.toLowerCase()) && !a.ticker.toLowerCase().startsWith(input.toLowerCase())) return 1;
            if (a.ticker.toLowerCase().includes(input.toLowerCase()) && !b.ticker.toLowerCase().includes(input.toLowerCase())) return -1;
            if (b.ticker.toLowerCase().includes(input.toLowerCase()) && !a.ticker.toLowerCase().includes(input.toLowerCase())) return 1;
            return a.ticker.localeCompare(b.ticker); // fallback sorting
        });
        return rel
    };


    const fetchSuggestions = (id, value) => {
        if (value.length > 0) {
            // const suggest = allStocks.sort((a, b) => levenshteinDistance(value, a) - levenshteinDistance(value, b)).slice(0, 10);
            const suggest = sortByRelevancy(value, allStocks).slice(0, 10);
            setSuggestions(prevItems => {
                const index = prevItems.findIndex(item => item.id === id);
                if (index !== -1) {
                    return prevItems.map((item, item_key) =>
                        item.id === id ? { id: id, suggest: suggest } : item
                    );
                } else {
                    return [...prevItems, { id: id, suggest: suggest }];
                }
            });
        } else {
            setSuggestions([]);
        }
    };

    const handleChange = (e, id) => {
        const { name, value } = e.target;
        const target_account = account.accounts.find(obj => obj.account_id === id);
        target_account.query = value
        const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === id ? target_account : obj);
        setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
        fetchSuggestions(id, value);
    };

    const handleAccountSelect = (event, accountNumber) => { //This will transition from selection from dropdown to row based vis/non-vis eye click
        const target_account = account.accounts.find(obj => obj.account_id === accountNumber); //not sure here will need to align with onclick
        setLoading({ [accountNumber]: true });
        setModalStatus(false);
        setCurrentWatchlistStock('');
        setCurrentStock('');
        if (demo && demoState === 2) {
            setDemoState(demoState + 1);
        }

        if (target_account.visible) {
            const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === accountNumber ? { ...obj, visible: false } : obj);
            setLoading({ [accountNumber]: false });
            setAccount(prev => ({ ...prev, accounts: updated_accounts }));
        }
        else {
            target_account.query = ""
            target_account.visible = true
            const fetchData = async () => {
                const response = await account_view(token, accountNumber);
                target_account.account_view = response
                const data_tickers = [...new Set([...Object.keys(response.watchlist), ...response.positions.map(x => x.ticker)])]
                const data_response = await get_data(token, accountNumber, data_tickers);
                target_account.data = data_response;
                const pulled_models = await get_models(token);
                setModels(pulled_models.models);
                if (target_account.account_view.tasks.length > 0) {
                    setJobs(target_account.account_view.tasks);
                    target_account.tasks = target_account.account_view.tasks;
                }
                else {
                    target_account.tasks = "";
                }
                setLoading({ [accountNumber]: false });
            };
            fetchData();
            const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === accountNumber ? target_account : obj);

            setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
            setShowMods(false);
        }
    };

    const handleSelect = (e, stock, accountNumber) => {
        e.preventDefault();
        if (demo && demoState === 3) {
            setDemoState(demoState + 1);
        }
        const active_account = account.accounts.find(acc => acc.account_id === accountNumber);
        const updated_watchlist = active_account.account_view.watchlist;
        const new_watchlist = updated_watchlist === null || Object.keys(updated_watchlist).length === 0 ? { [stock.ticker]: { buy: true, sell: true } } : { ...updated_watchlist, [stock.ticker]: { buy: true, sell: true } };
        // console.log(new_watchlist);
        const submitPost = async () => {
            const post_response = await post_watchlist(token, new_watchlist, accountNumber);
            const data_tickers = [...new Set([...Object.keys(new_watchlist), ...active_account.account_view.positions.map(x => x.ticker)])]
            const data_response = await get_data(token, accountNumber, data_tickers)
            if (Object.keys(post_response).length > 0) {
                // console.log(post_response);
                active_account.account_view.watchlist = new_watchlist;
                active_account.data = data_response
                active_account.query = ""
                const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === accountNumber ? active_account : obj)
                setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
            }
        };
        submitPost();
        setSuggestions([]);
    };

    const handleEnterSelect = (e, accountId) => {
        if (e.key !== 'Enter') return;
        e?.preventDefault?.();

        const target_account = account.accounts.find(obj => obj.account_id === accountId);

        const currentQuery = target_account?.query || "";
        const cleanedQuery = currentQuery.trim().toLowerCase();
        const longList = sortByRelevancy(cleanedQuery, allStocks)
        const exactMatch = longList.find((item) => {
            if (!item) return false;
            const itemText = typeof item === 'object' ? item.ticker : String(item);
            return (itemText || "").trim().toLowerCase() === cleanedQuery;
        });
        if (exactMatch) {
            handleSelect(e, exactMatch, accountId);
        } else {
            console.log("No match found. Doing nothing.");
        }
    };

    const openPopup = async (e) => {
        e?.preventDefault?.();

        if (demoUser) {  // && demo if you want to allow demoUser to see Schwab integration pop up
            // Refresh the page instead of opening a popup
            // window.location.reload();
            if (demoState === 1) {
                setDemoState(demoState + 1);
            }
            setAccount({ ...account, status: true })
            return;
        }

        const popup = window.open(authContext.authorization_url, 'popup', 'width=600,height=400');
        const params = new URLSearchParams(location.search);
        const shouldRefresh = params.get("refresh") === "true";
        if (shouldRefresh) {
            const newUrl = window.location.pathname + window.location.hash;
            window.history.replaceState(null, '', newUrl);
            setReconFlag(false);
        }

        // Listen for the callback URI
        const interval = setInterval(() => {
            try {
                if (popup.location.href.includes('code')) {
                    setCallbackUri(popup.location.href);
                    clearInterval(interval);
                    provisionAdd(e, popup.location.href);
                    popup.close();
                } else {
                    // console.log(popup.location.href);
                }
            } catch (error) {
                console.error('Error accessing popup location:', error);
            }
        }, 2000);
    };

    const openPopupReconnect = async (e) => {
        e?.preventDefault?.();
        if (showMods) {
            openPopup(e);
        }
        if (demo && account.accounts.length === 0) {
            setDemoState(1);
        }
        const fetchAuthContextURL = async () => {
            const accountResponse = await get_configure(token);
            setAuthContext({ authorization_url: accountResponse.authorization_url, callback_url: accountResponse.callback_url, state: accountResponse.state })
            setCallbackUri('');
            if (account.accounts.length === 0) {
                if (demoUser) {
                    setAccount({ ...account, status: false });
                }
                else {
                    setAccount(prev => ({ status: false }));
                }
            }
            else {
                const updated_accounts = account.accounts.map((obj, o_key) => ({ ...obj, visible: false }));
                setAccount(prev => ({ ...prev, accounts: updated_accounts }));
                setShowMods(true);
                setDemoState(9);
            }
        };
        fetchAuthContextURL();

    };

    const handleOpenPopup = async (e, reconnnect) => {
        e.preventDefault();
        setWarnModalStatus(true);
        setWarnExit(reconnnect);
    }

    const handleCloseWarnModal = async (e) => {
        e?.preventDefault?.();
        setWarnModalStatus(false);
        if (warnExit) {
            openPopupReconnect(e);
        }
        else {
            openPopup(e);
        }
    }

    const provisionAdd = async (e, callback_uri) => {
        e?.preventDefault?.();
        setAccountsLoading(true);
        const submitProvisional = async () => {
            const response = await configure({ accessToken: token, auth_cont: authContext, url: callback_uri });
            if (response.status) {
                setAccount(response)
            }
            setAccountsLoading(false);
        };
        submitProvisional();
    };


    const handleModalStatus = async (e, accountNumber) => {
        e.preventDefault();
        setSelectedAccount(accountNumber);
        setModalStatus(!modalStatus)
    }

    const handleJobClear = async (e, selectedAccount) => {
        e.preventDefault();
        if (demo && demoState === 7) {
            setDemoState(demoState + 1)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
        const submitClear = async () => {
            const response = await clear_job(token, selectedAccount);
        };
        const target_account = account.accounts.find(obj => obj.account_id === selectedAccount);
        target_account.tasks = "";
        const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === selectedAccount ? target_account : obj);
        setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
        setJobs([]);
        submitClear();

    }

    const handleRemoveWatchlist = (e, accountNumber) => { //This is another place that we should evaluate the response post returns btoh watchlist data and watchlist data newaccounts can be updated after the call using that data.
        e.preventDefault();
        const newAccounts = account.accounts
        const newAccount = newAccounts.find(acc => acc.account_id === accountNumber)
        const newWatchlist = newAccount.account_view.watchlist
        delete newWatchlist[currentWatchlistStock.currentStock]
        newAccount.account_view.watchlist = newWatchlist
        const updated_accounts = newAccounts.map((acc, a_key) => acc.account_id === accountNumber ? newAccount : acc)
        account.accounts = updated_accounts.sort((a, b) => a.account_id - b.account_id)
        // console.log(newWatchlist)
        const submitPost = async () => {
            const post_response = await post_watchlist(token, newWatchlist, accountNumber);
        };
        submitPost();
        setCurrentWatchlistStock('');
    }

    const handleRemoveWatchlistWithoutCurrent = (e, accountNumber, currentWatchlistTarget) => {
        e.preventDefault();
        if (demo && demoState === 4) {
            setDemoState(demoState + 1)
        }
        const newAccounts = account.accounts
        const newAccount = newAccounts.find(acc => acc.account_id === accountNumber)
        const newWatchlist = newAccount.account_view.watchlist
        // const newWatchlistData = newAccount.account_view.data TODO: This commenting on newWatchlistData. I do not think I can safely delete it since it is a union of watchlist and holdings if I delete data then I may delete something that is later referenced on the holdings side.
        delete newWatchlist[currentWatchlistTarget]
        // delete newWatchlistData[currentWatchlistTarget]
        newAccount.account_view.watchlist = newWatchlist
        // newAccount.account_view.data = newWatchlistData
        // console.log(newWatchlist)
        const updated_accounts = newAccounts.map((acc, a_key) => acc.account_id === accountNumber ? newAccount : acc)
        const show = account.accounts.find(acc => acc.account_id === accountNumber)
        const submitPost = async () => {
            const post_response = await post_watchlist(token, newWatchlist, accountNumber);
        };
        submitPost();
        setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
        setCurrentWatchlistStock('');
    }

    const handleSetCurrentWatchlistStock = (stock) => {
        setCurrentStock('');
        setCurrentWatchlistStock(stock);
    }

    const handleClearWatchlistStock = (e) => {
        e.preventDefault();
        setCurrentWatchlistStock('');
    }

    const handleSetCurrentStock = (stock) => {
        if (demo && demoState === 5) {
            setDemoState(demoState + 1);
        }
        setCurrentWatchlistStock('');
        setCurrentStock(stock)
    }

    const handleClearCurrentStock = (e) => {
        e.preventDefault();
        setCurrentStock('');
    }

    const handleOnCheck = (e, id, stock, action, value) => {
        e.preventDefault();
        if (demo && demoState === 3) {
            setDemoState(demoState + 1);
        }
        const active_account = account.accounts.find(acc => acc.account_id === id);
        const updated_watchlist = active_account.account_view.watchlist;
        const buyValue = action === 'buy' ? !updated_watchlist[stock].buy : updated_watchlist[stock].buy
        const sellValue = action === 'sell' ? !updated_watchlist[stock].sell : updated_watchlist[stock].sell
        const new_watchlist = { ...updated_watchlist, [stock]: { buy: buyValue, sell: sellValue, limit: updated_watchlist[stock].limit } }; //TODO: Set this to {"stock": {buy: true, sell: false}}
        const submitPost = async () => {
            const post_response = await post_watchlist(token, new_watchlist, id);
            if (Object.keys(post_response).length > 0) {
                active_account.account_view.watchlist = post_response;
                active_account.query = ""
                const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === id ? active_account : obj)
                setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
            }
        };
        submitPost();
        setSuggestions([]);
    }

    const handleStockTarget = (e, id, stock, limit) => {
        e.preventDefault();
        const active_account = account.accounts.find(acc => acc.account_id === id);
        const updated_watchlist = active_account.account_view.watchlist;
        const new_watchlist = { ...updated_watchlist, [stock]: { buy: updated_watchlist[stock].buy, sell: updated_watchlist[stock].sell, limit: limit } };
        const submitPost = async () => {
            const post_response = await post_watchlist(token, new_watchlist, id);
            if (Object.keys(post_response).length > 0) {
                active_account.account_view.watchlist = post_response;
                active_account.query = ""
                const updated_accounts = account.accounts.map((obj, o_key) => obj.account_id === id ? active_account : obj)
                setAccount(prev => ({ ...prev, accounts: updated_accounts.sort((a, b) => a.account_id - b.account_id) }));
            }
        };
        submitPost();
    }

    const handleDropdown = (e) => {
        e.preventDefault();
        setControlsDropdown(!controlsDropdown)
    }

    const Tooltip = ({ targetRef, tipTitle = "", message, addTop = 0, addRight = 0, tuneTop = false, tuneRight = false }) => {
        const [coords, setCoords] = useState({ top: 0, left: 0 });

        useEffect(() => {
            if (targetRef.current) {
                const rect = targetRef.current.getBoundingClientRect();
                setCoords({ top: rect.top + window.scrollY + addTop, right: window.innerWidth - rect.right + addRight });
            }
        }, [targetRef]);
        const top = `${coords.top}px`
        const right = `${coords.right}px`


        const triangleTop = coords.top + 5;
        const triangleRight = coords.right - 10;
        const topT = `${triangleTop}px`
        const rightT = `${triangleRight}px`

        const tuneTopVal = `${triangleTop + 50}px`
        const tuneRightVal = `${triangleRight}px`
        return ReactDOM.createPortal(
            <>
                <ToolTipContainer top={top} right={right} tuneTop={tuneTop} tuneTopVal={tuneTopVal} tuneRight={tuneRight} tuneRightVal={tuneRightVal} >
                    <ToolTipTopLine>{tipTitle}</ToolTipTopLine>
                    <ToolTipP>{message}</ToolTipP>
                    <ToolTipFooter>
                        {/* <ToolTipControl onClick={() => increaseDemoState()}>Next</ToolTipControl> */}
                        <>{`${demoState}/9`}</>
                    </ToolTipFooter>
                </ToolTipContainer>
                <ToolTipPointer top={topT} right={rightT} tuneTop={tuneTop} tuneTopVal={tuneTopVal} tuneRight={tuneRight} tuneRightVal={tuneRightVal} />
            </>,
            document.body
        );
    };

    const handleToolTips = () => {
        setLast(demoState)
        const state = showMods ? 9 : account.status ? account.accounts.some(x => x.visible === true) ? Math.max(last, 3) : 2 : 1;
        setDemoState(demo ? 0 : state);
        setDemo(!demo);
    }

    const handleAccountCheckmark = (event, accountNumber) => {
        if (checkmarkedAccounts.find(ac => ac === accountNumber)) {
            setCheckmarkedAccounts([...checkmarkedAccounts.filter(ac => ac != accountNumber)]);
        } else {
            setCheckmarkedAccounts([...checkmarkedAccounts, accountNumber])
        }
    };

    const handleRemoveAccounts = (e) => {
        e.preventDefault();

        const fetchData = async () => {
            let toDelete = checkmarkedAccounts;

            if (demo) {
                const accountToKeep = account.accounts[0]; // always keep first account
                toDelete = checkmarkedAccounts.filter(id => id !== accountToKeep.account_id);
            }

            await Promise.all(
                toDelete.map((id, id_key) => account_delete(token, id))
            );

            window.location.reload();
        };

        fetchData();
    };

    const increaseDemoState = () => {
        if (demoState < 9) {
            setDemoState(demoState + 1);
        }
        else {
            const state = account.status ? account.accounts.some(x => x.visible === true) ? 3 : 2 : 1;
            setDemoState()
        }
    }

    const handleCloseMods = (e) => {
        e.preventDefault();
        setCheckmarkedAccounts([]);
        setShowMods(false);
        setDemoState(2);
    }

    const handleDeleteModal = async (e) => {
        e.preventDefault();
        setDeleteModalStatus(!deleteModalStatus)
    }

    return (
        <>
            {status ? (
                <AccountContainer>
                    <Form>
                        <HeaderContainer ref={reconRef} >
                            <FormH1>Accounts</FormH1>
                            <ToggleButtonWrapper>
                                <ToggleWrapper>
                                    <ToggleSwitch>
                                        <HiddenCheckbox
                                            checked={demo}
                                            onChange={handleToolTips}
                                        />
                                        <Slider>
                                            <TipBox demo={demo}>Tooltips</TipBox>
                                            <IconWrapper className="icon-wrapper">
                                                {demo ? <TipsOff size={16} color="black" /> : <TipsOn size={16} color="#cc8f2d" />}
                                            </IconWrapper>
                                        </Slider>
                                    </ToggleSwitch>
                                </ToggleWrapper>
                                {showMods && <StyledIconContainer style={{ background: 'black', height: '26px', borderRadius: '50px', justifyContent: 'space-evenly', margin: '2px' }}>
                                    <>
                                        {checkmarkedAccounts.length === 0 ? <StyledIconLink onClick={(e) => handleOpenPopup(e, true)} /> : <StyledIconRefresh onClick={(e) => handleOpenPopup(e, true)} />}
                                        < RemoveAccountButton style={{
                                            opacity: checkmarkedAccounts.length === 0 ? 0.2 : 1,
                                        }} onClick={(e) => checkmarkedAccounts.length === 0 ? null : handleDeleteModal(e)} />
                                        <HeaderClose onClick={(e) => handleCloseMods(e)} />
                                    </>
                                </StyledIconContainer>
                                }
                                {!showMods && account.status && <FormButton style={{ margin: '2px', marginTop: '3px', height: '26px', borderRadius: '50px', fontSize: '18px' }} showMods={showMods} onClick={(e) => openPopupReconnect(e)}>{showMods ? "+" : "Modify Accounts"}</FormButton>}
                                {demoState === 8 && demo && <Tooltip tipTitle={"Account Modification"} targetRef={reconRef} addTop={-2} addRight={220} tuneTop={true} tuneRight={true} message={"Add your accounts"} />}
                            </ToggleButtonWrapper>
                        </HeaderContainer>
                        {account.status ?
                            <>
                                {account.accounts.map((ac, key) => (
                                    <RowContainer key={key}>
                                        {ac.visible ?
                                            <>
                                                <AccountRow>
                                                    <FormH3>Account:   {ac.account_four}</FormH3>
                                                    <StyledIconSlashButton onClick={(e) => handleAccountSelect(e, ac.account_id)} />
                                                </AccountRow>
                                                <FormInputDropdownContainer ref={dropdownRef}>
                                                    <FormInput
                                                        type="text"
                                                        name="query"
                                                        autoComplete="off"
                                                        value={ac.query}
                                                        onChange={(e) => handleChange(e, ac.account_id)}
                                                        onKeyDown={(e) => handleEnterSelect(e, ac.account_id)}
                                                        placeholder="Trade List"
                                                    />
                                                    <DropdownContainer>
                                                        {suggestions.filter(x => x.id === ac.account_id).map((suggestions, s_key) => suggestions.suggest.map((stock, st_key) =>
                                                            <WatchlistRow placeholder={stock.ticker} onClick={(e) => handleSelect(e, stock, ac.account_id)}>
                                                                {stock.ticker}
                                                            </WatchlistRow>
                                                        ))}
                                                    </DropdownContainer>
                                                </FormInputDropdownContainer>
                                                {demoState === 3 && demo && <Tooltip targetRef={dropdownRef} addTop={-2} addRight={212} tipTitle={"Trade List"} message={"Search tickers to add stocks to your trade list"} />}
                                                <AccountRow2>
                                                    <StyledIconTable selected={view === "Table"} onClick={(e) => setView("Table")} />
                                                    <StyledIconPie selected={view === "Pie"} onClick={(e) => setView("Pie")} />
                                                </AccountRow2>
                                                {loading[ac.account_id] === true &&
                                                    <SpinningIcon />
                                                }
                                                {ac.account_view && view === "Pie" &&
                                                    <PortfolioPieChart id={ac.account_id} watchlist={ac.account_view.watchlist ? Object.keys(ac.account_view.watchlist) : []} holdings={[...ac.account_view.positions, { ticker: 'CASH', shares: ac.account_view.cash, cost: '1.00' }]} setCurrentStock={handleSetCurrentStock} setWatchlistStock={handleSetCurrentWatchlistStock} handleRemoveFromWL={handleRemoveWatchlistWithoutCurrent} demoState={demoState} demo={demo} />
                                                }
                                                {ac.account_view && view === "Table" &&
                                                    <LTTable id={ac.account_id} watchlist={ac.account_view.watchlist} holdings={[...ac.account_view.positions, { ticker: 'CASH', shares: ac.account_view.cash, cost: 1.00, label: "CASH" }]} data={ac.data} setCurrentStock={handleSetCurrentStock} setWatchlistStock={handleSetCurrentWatchlistStock} handleRemoveFromWL={handleRemoveWatchlistWithoutCurrent} demoState={demoState} demo={demo} />
                                                }
                                                {currentWatchlistStock.id === ac.account_id &&
                                                    <ChartStation handleRemoveWatchlist={handleRemoveWatchlist} handleClearWatchlistStock={handleClearWatchlistStock} handleOnCheck={handleOnCheck} currentWatchlistStock={currentWatchlistStock} watchlist_stock={ac.account_view.watchlist[currentWatchlistStock.currentStock]} stock_data={ac.data[currentWatchlistStock.currentStock]} token={token} selectedAccount={ac.account_id} handleStockTarget={handleStockTarget} />
                                                }
                                                {currentStock.id === ac.account_id &&
                                                    (
                                                        currentStock.currentStock.label != 'CASH' ?
                                                            <PortfolioChartStation handleClearCurrentStock={handleClearCurrentStock} currentStock={currentStock.currentStock} stock_data={ac.data[currentStock.currentStock.ticker]} token={token} trades={['some']} selectedAccount={ac.account_id} />
                                                            : <></>
                                                    )
                                                }
                                                {!ac.tasks &&
                                                    <>
                                                        {modalStatus ?
                                                            <></>
                                                            : (
                                                                <FormInputDropdownContainer>
                                                                    <FormButton ref={runTraderRef} onClick={(e) => handleModalStatus(e, ac.account_id)}>Start Trading</FormButton>
                                                                    {demoState === 6 && demo && <Tooltip targetRef={runTraderRef} addTop={-2} addRight={220} tuneRight={true} tipTitle={"Trigger Agents"} message={"Initialize the Lay Trader autonomous trading agents"} />}
                                                                </FormInputDropdownContainer>
                                                            )
                                                        }
                                                    </>
                                                }
                                                {ac.tasks &&
                                                    <FormInputDropdownContainer >
                                                        {ac.tasks.map((job, j_key) => (
                                                            <JobsContainer>
                                                                <JobsStatusContainer>
                                                                    <RowInfoStack>
                                                                        <JSInfoH1>Last Run</JSInfoH1>
                                                                        <JSInfoText>{job.last_run_time ? `${job.last_run_time.split(" ")[0]} ${job.last_run_time.split(" ")[1].split("-")[0].replace(/^0+/, '')} ET` : "Pending"}</JSInfoText>
                                                                    </RowInfoStack>
                                                                    <RowInfoStack>
                                                                        <JSInfoH1>Next Run</JSInfoH1>
                                                                        <JSInfoText>{job.next_run_time.slice(0, 16)} ET</JSInfoText>
                                                                    </RowInfoStack>
                                                                </JobsStatusContainer>
                                                                <FormButton ref={clearJobRef} style={{ justifySelf: 'center' }} onClick={(e) => handleJobClear(e, ac.account_id)}>Stop Trading</FormButton>
                                                                {demoState === 6 && demo && <Tooltip targetRef={clearJobRef} addTop={-2} addRight={220} tipTitle={"Halt Agents"} tuneRight={true} message={"View action times for active agents and control execution"} />}
                                                                {demoState === 7 && demo && <Tooltip targetRef={clearJobRef} addTop={-2} addRight={220} tipTitle={"Halt Agents"} tuneRight={true} message={"View action times for active agents and control execution"} />}
                                                            </JobsContainer>
                                                        ))}
                                                    </FormInputDropdownContainer>
                                                }
                                            </> :
                                            <AccountRow>
                                                <FormH3>Account:   {ac.account_four}</FormH3>
                                                <StyledIconContainer ref={visibleButton}>
                                                    {showMods && <StyledCheckbox onChange={(e) => handleAccountCheckmark(e, ac.account_id)}></StyledCheckbox>}
                                                    {!showMods && <StyledIconButton onClick={(e) => handleAccountSelect(e, ac.account_id)} />}
                                                </StyledIconContainer>
                                                {demoState === 9 && demo && <Tooltip targetRef={visibleButton} addTop={-10} addRight={50} tipTitle={"Account Modification"} message={"Delete your account or close account modification"} />}
                                                {demoState === 2 && demo && <Tooltip targetRef={visibleButton} addTop={3} addRight={50} tipTitle={"Account Visibility"} message={"View Lay Trader account details and access your trading agents"} />}
                                            </AccountRow>
                                        }
                                    </RowContainer>))
                                }
                                <RunModal isOpen={modalStatus} onClose={(e) => handleModalStatus(e)} models={models} selectedAccount={selectedAccount} token={token} accounts={account} setAccounts={setAccount} setDemoState={setDemoState} isAdmin={adminUser} />
                                <DeleteModal isOpen={deleteModalStatus} onClose={(e) => handleDeleteModal(e)} deleteAccounts={handleRemoveAccounts} />
                            </> : (
                                <>
                                    {callbackUri ?
                                        <>
                                            {accountsLoading === true &&
                                                <SpinningIcon />
                                            }
                                        </>
                                        : (
                                            awaitingAccountResponse ? <SpinningIcon /> : <>
                                                <FormButton ref={connectRef} onClick={(e) => handleOpenPopup(e, false)}>Connect Account</FormButton>
                                                {demoState === 1 && demo && <Tooltip targetRef={connectRef} addTop={-2} addRight={220} tuneRight={true} tipTitle={"Account Authorization"} message={"Authorize existing brokerage accounts through the authorization workflow"} />}
                                            </>
                                        )}
                                </>
                            )
                        }
                        <WarnModal isOpen={warnModalStatus} onClose={(e) => handleCloseWarnModal(e)} />
                    </Form>
                </AccountContainer >
            ) : <></>}
        </>
    );
};

export default AccountPage;
